/** Strips diacritics (z-caron -> z, y-acute -> y, etc.) by dropping combining marks. */
const removeDiacritics = (value: string) =>
  value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

/**
 * Normalizes a string into a referral-code-safe slug:
 * lowercased ASCII, spaces collapsed to dashes, everything else dropped.
 */
export const slugify = (value: string) =>
  removeDiacritics(value)
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
